import { FC } from 'react';

import { ParkingBookingDateField } from '../../ParkingBookingSettings/ParkingBookingDateField';
import { ParkingBookingTimeField } from '../../ParkingBookingSettings/ParkingBookingTimeField';
import { ParkingOfficeSidesheetButton } from '../../ParkingOffice/ParkingOfficeSidesheetButton';
import { ParkingSearch } from '../../ParkingSearch/ParkingSearch';

import classes from './MobilePageActions.module.scss';

export const MobilePageActions: FC = () => {
  return (
    <div className={classes.container}>
      <div className={classes.office}>
        <ParkingOfficeSidesheetButton />
      </div>
      <div className={classes.date}>
        <ParkingBookingDateField />
      </div>
      <div className={classes.time}>
        <ParkingBookingTimeField />
      </div>
      <div className={classes.controls}>
        <div className={classes.search}>
          <ParkingSearch />
        </div>
      </div>
    </div>
  );
};
